import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagingComponent } from './Components/paging/paging.component';
import { NotificationComponent } from './Components/notification/notification.component';

import { FormsModule } from '@angular/forms';
import { HijriDatePipe } from './pipes/hijri.pipe';
import { GorgianDatePipe } from './pipes/gorgian-date.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { PureTextPipe } from './pipes/pure-text.pipe';


@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [
    PagingComponent,
    NotificationComponent,
    HijriDatePipe,
    GorgianDatePipe,
    TimeFormatPipe,
    PureTextPipe
  ],
  declarations: [
    PagingComponent,
    NotificationComponent,
    HijriDatePipe,
    GorgianDatePipe,
    TimeFormatPipe,
    PureTextPipe
  ],
})
export class SharedModule {}
